import React from 'react';
import { PropTypes } from 'prop-types';
import Tooltip from 'components/Tooltip';
import TextIcon from 'components/TextIcon';
import DrawTooltip from './components/DrawTooltip';
import { useSelector } from 'react-redux';
import { selectors as settingsSelector } from 'state/settings';
import { useOrderStop } from 'components/orders/OrderStop/UseOrderStop';

const StandstillIncident = ({ stop }) => {
  const { getStandstillLabel, getStandstillLabelParams, standstillType } =
    useOrderStop();
  const getStandstillConfigByStopLoad = useSelector(
    settingsSelector.getStandstillConfigByStopLoad
  );
  const standstillConfig = getStandstillConfigByStopLoad(stop);
  const label = getStandstillLabel(standstillConfig);
  const tooltipParams = getStandstillLabelParams(standstillConfig);

  if (!label) {
    return null;
  }

  return (
    <span
      title={label}
      className={`status-text warning`}
      data-testid="standstill-incident"
    >
      {label}
      <Tooltip
        component={
          <DrawTooltip
            tooltip={standstillType}
            params={tooltipParams}
            totalItems={stop.total_pickup_pallets}
          />
        }
        skin="light"
        position="bottom"
        segmentTitle="order stop - more info"
      >
        &nbsp;
        <TextIcon className="warning">?</TextIcon>
      </Tooltip>
    </span>
  );
};

StandstillIncident.propTypes = {
  stop: PropTypes.object.isRequired,
};

export default StandstillIncident;
